const about =
{
    alternativeHeadline :
    {
        caption  : 'Accroche destinée à attirer l\'attention.',
        title    : 'Sous-Titre' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    },
    description :
    {
        caption  : 'Un texte court, un résumé du propos développé dans cette fiche.',
        title    : 'Description' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    },
    headline :
    {
        caption  : 'Titre principal de cette fiche.',
        title    : 'Titre' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    },
    notes :
    {
        caption  : 'Anectdotes, précautions, remarques, etc. ',
        title    : 'Notes' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    },
    text :
    {
        caption  : 'Texte principal de cette fiche.',
        title    : 'Texte' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    }
};

export default about ;